export type PreviewPage = {
  src: string;
  alt: string;
};

export const previewPages: PreviewPage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/jykf95QvwuLAjH7wTGUkLm/IMG_2666.jpg',
    alt: 'Sample page: Every automated process depends on connected functions — sensors, controllers, actuators, motors and drives, operator interfaces and electrical infrastructure',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/ozRL9qfRxw4AeoNjs943vm/IMG_2667.jpg',
    alt: 'Sample page: From product detection to controlled movement — a conveyor line showing detection, control evaluation, command, response and feedback',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/kc95veNngbY6Zyv8QeTWJa/IMG_2668.jpg',
    alt: 'Sample page: What is happening vs. what should be happening — setpoint, process variable, controlled variable, manipulated variable and disturbance',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/mycWg6ppqkM9aQR9YkM16q/IMG_2669.jpg',
    alt: 'Sample page: One control technology, many industrial applications — manufacturing, material handling, packaging, water systems, food processing and industrial utilities',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/9QU4Hk3NuiPs5qbEMJNmhj/IMG_2670.jpg',
    alt: 'Sample page: How a modern automated facility works as one system — production, detection, control, equipment response, supervision and maintenance',
  },
];
